import React from 'react';

function AboutComponent() {
    return (
        <section className='about-section-home py-5'>
            <div className="section-ornament">
                <span className="ornament-line"></span>
                <span className="ornament-diamond"></span>
                <span className="ornament-line"></span>
            </div>
            <div className="container">
                <div className="row">
                    <div className="col">
                        <div className='text-center headCenter mx-auto my-lg-4'>
                            <span className="section-label d-block mb-2">Welcome</span>
                            <h2 className='whyHeadFont mt-2'>Best Mehandi In Malappuram, Kerala</h2>
                            <p className='whyPara mt-4'>
                                Mehandi, often referred to as henna, is a time-honored art form that has transcended
                                generations and cultures. This exquisite tradition involves the application of intricate
                                and ornate designs on the skin, primarily on the hands and feet, using a paste made from
                                the leaves of the henna plant. Beyond its aesthetic appeal, Mehandi carries deep cultural
                                significance, symbolizing joy, celebration, and the sacred bond of love.
                            </p>
                            <p className='whyPara'>
                                As a Mehandi artist, I am dedicated to preserving this ancient art form and creating bespoke
                                designs that blend tradition with contemporary aesthetics, allowing individuals to express
                                their unique stories and emotions through the language of henna.
                            </p>
                        </div>
                    </div>
                </div>

                <div className="row mt-4 g-4 justify-content-center text-center">
                    <div className="col-6 col-md-3">
                        <div className="stat-card">
                            <h3 className="stat-number">500+</h3>
                            <p className="stat-label">Happy Brides</p>
                        </div>
                    </div>
                    <div className="col-6 col-md-3">
                        <div className="stat-card">
                            <h3 className="stat-number">8+</h3>
                            <p className="stat-label">Years Experience</p>
                        </div>
                    </div>
                    <div className="col-6 col-md-3">
                        <div className="stat-card">
                            <h3 className="stat-number">1000+</h3>
                            <p className="stat-label">Events Done</p>
                        </div>
                    </div>
                    <div className="col-6 col-md-3">
                        <div className="stat-card">
                            <h3 className="stat-number">4</h3>
                            <p className="stat-label">Mehandi Styles</p>
                        </div>
                    </div>
                </div>
            </div>
            <div className="section-ornament mt-4">
                <span className="ornament-line"></span>
                <span className="ornament-diamond"></span>
                <span className="ornament-line"></span>
            </div>
        </section>
    );
}

export default AboutComponent;
